import { Space, Text } from "@/atoms"
import { Heading } from "@/molecules/Heading"
import { Item, List } from "@/pages/DiscoveryPage/components/molecules/List"
import { Fragment } from "react"
import { ThirdPartyFixesList } from "./ThirdPartyFixesList"
import { findingsToThirdPartySources } from "./utils"

import type { ThirdPartyFinding, ThirdPartyFix } from "@/domain/issue"
import type { BaseCardComponentProps } from "../../../RemediationGuide.types"

import styles from "./ThirdPartyFixes.module.scss"

export const ThirdPartyFixes: React.FC<
  BaseCardComponentProps & {
    thirdPartyFindings: ThirdPartyFinding[]
    copyable?: boolean
  }
> = ({ thirdPartyFindings, copyable, t, tKey }) => {
  const thirdPartySources = findingsToThirdPartySources(thirdPartyFindings)
  const allThirdPartyFixes: ThirdPartyFix[] = thirdPartySources
    .map((f) => f.remedies)
    .flat()
  const hasFixes = allThirdPartyFixes.length > 0
  const hasSingleThirdPartyImages = thirdPartySources.length === 1

  return (
    <Space orientation="vertical">
      {!hasFixes ? (
        <>
          <Heading level={6} title={`${t(`${tKey}thirdPartyImageUpdate`)}:`} />
          <div className={styles.noFixContainer}>
            <Text style={{ whiteSpace: "pre-line" }}>
              {t(`${tKey}undeterminedThirdPartyFix`)}
            </Text>
          </div>
        </>
      ) : (
        <>
          <Heading
            level={6}
            title={`${t(`${tKey}updateThirdPartyImage`, { count: thirdPartySources.length })}:`}
          />
          {hasSingleThirdPartyImages ? (
            <ThirdPartyFixesList
              fixes={thirdPartySources[0].remedies}
              copyable={copyable}
              t={t}
            />
          ) : (
            <List
              limit={copyable ? undefined : 2}
              items={thirdPartySources}
              Component="ol"
              classes={{ list: styles.sourcesList }}
              render={({ tag, remedies }) => (
                <Fragment key={tag}>
                  <Item
                    title={tag}
                    classes={{
                      item: styles.thirdPartySourceItem,
                      title: styles.thirdPartySourceTitle
                    }}
                  />
                  <ThirdPartyFixesList
                    fixes={remedies}
                    copyable={copyable}
                    t={t}
                  />
                </Fragment>
              )}
            />
          )}
        </>
      )}
    </Space>
  )
}
